import PropTypes from 'prop-types';
import React from 'react';
import ApplePay from '../../components/ApplePay';

const Pay = ({ onClick }) => (
  <div className="u-text-center u-pt">
    <ApplePay
      className="u-1/1 u-1/2-medium-and-up"
      onClick={onClick}
    />
  </div>
);
Pay.propTypes = {
  onClick: PropTypes.func,
};
Pay.defaultProps = {
  onClick: null,
};

export default Pay;




// WEBPACK FOOTER //
// ./src/app/reservation/components/ApplePay.jsx